
 import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
// import GraduatesTestimonial from './GraduatesTestimonial.vue'
// import GraduatesTestimonial from './GraduatesTestimonial.vue';
import reviewData from '@/data/promoReviews.json'
export default {
  components:{ SsrCarousel, },
  props: {
    id: {
      default: '',
      type: String,
    },
    img_left: {
      default: 'https://cdn-wp.tefl.org/wp-content/uploads/2022/05/student_stories_slides_david.jpg',
      type: String,
    },
    url_left: {
      default: '/blog/the-paradigm-shift-of-teaching-english-online/',
      type: String,
    },
    alt_left: {
      default: 'David digital nomad',
      type: String,
    },
    img_right: {
      default: 'https://cdn-wp.tefl.org/wp-content/uploads/2022/05/student_stories_slides_frances.jpg',
      type: String,
    },
    url_right: {
      default: '/blog/frances-vietnam-tefl-guide/',
      type: String,
    },
    alt_right: {
      default: 'Frances in Vietnam',
      type: String,
    },
    nochild:{
      default: 1,
      type: Number
    },
    children:{
      default: "",
      type:String
    }
  },
  data() {
    return {
      carouselLoaded:false,
      carouselKey:1,
      reviews: reviewData,
      settings: {
          autoplay: true,
          autoplaySpeed: 10000,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows:false
      }
    }
  },
  computed:{
    gcontent(){
return JSON.parse(decodeURIComponent(this.$props.children))
    },
  },
    
  mounted() {
    this.setCarouselLoaded();
  },
  beforeUpdate() {
    // this.setCarouselLoaded();
  },
  methods: {
    setCarouselLoaded() {
      // console.log('Checking graduate slots... ',this.$slots.default[0])
      this.carouselLoaded = !!this.$slots.default && !!this.$slots.default[0]
      console.log('graduatesLoaded ',this.carouselLoaded)
    },
  },

}
